import { useNavigate } from "react-router-dom";

export default function Logo({ className = "", showTagline = true, size = 64 }) {
  const navigate = useNavigate();
  
  return (
    <button 
      onClick={() => navigate("/")} 
      className={`flex flex-col items-center cursor-pointer hover:opacity-80 transition-opacity ${className}`}
    >
      <img
        src="/logo.png"
        alt="AyuPath - Your Next Chapter"
        width={size}
        height={size}
        style={{ height: size, width: "auto" }}
        className="flex-shrink-0"
        fetchpriority="high"
        decoding="async"
      />
      {showTagline && (
        <p className="mt-2 text-sm font-medium text-gray-700">
          Your Next Chapter
        </p>
      )}
    </button>
  );
}
